export const SET_PRODUCTION_GROUPING_TEAM_LIST = "SET_PRODUCTION_GROUPING_TEAM_LIST";
export const SET_PROJECT_ASSIGNMENT_LIST = "SET_PROJECT_ASSIGNMENT_LIST";
